import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BackgroundService {
  private backgroundColorSource = new BehaviorSubject<string>('#ffffff');
  backgroundColor$ = this.backgroundColorSource.asObservable();

  constructor() {}

  updateBackgroundColor(color: string) {
    this.backgroundColorSource.next(color);
  }
}
